/* eslint-disable no-undef */
document.addEventListener("DOMContentLoaded", () => {
    $(".nav-mobile-trigger").bind("click", () => {
        $(".nav-mobile-trigger").toggleClass("active");
        $(".nav-ul").toggleClass("active");
        $("body").toggleClass("active");
        $("html").toggleClass("active");
        $(".screen-1__header-wrapper").toggleClass("no-visible");
    });
});
